import Header from '@/components/header';
import Asidebar from '@/components/sidebar/sidebar';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { AuthProvider } from '@/context/auth-provider';
import { getCookie } from '@/lib/utils';
import { Outlet } from 'react-router-dom';

const AppLayout = () => {
    const _prevState = getCookie('_sbs');
    const defaultOpen = _prevState
        ? _prevState === 'true'
            ? true
            : false
        : true;

    return (
        <AuthProvider>
            <SidebarProvider defaultOpen={defaultOpen}>
                <Asidebar />

                <SidebarInset>
                    <main className='w-full'>
                        <Header />
                        <Outlet />
                    </main>
                </SidebarInset>
            </SidebarProvider>
        </AuthProvider>
    );
};

export default AppLayout;
